import { useRef, useEffect, useState } from "react";
import BODY from "./../../../../../../assets/checkup/humanBody.png";
import History from "./history";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import DiagHistory from "./diagHistory";
import { SetPATIENT } from "../../../../../../services/redux/slices/diagnostics/clinic/appointments";
import { getDepartment } from "../../../../../../services/utilities";
import { Templates } from "../../../../../../services/fakeDb";

export default function HumanBody({ setSlide, slide }) {
  const { patient: appointment } = useSelector(
    ({ appointments }) => appointments
  );
  const dispatch = useDispatch();
  const { patient } = appointment || {};

  const containerRef = useRef(null);
  const bodyRef = useRef(null);

  const ehr = ["FMHx", "PMHx", "PSHx", "SHx", "OB Gyne Hx"];
  const ancillary = ["Laboratory", "Radiology", "Vital", "Medications"];

  // <- dito ilagay ang iba't ibang laman para sa bawat button
  const contentMap = {
    FMHx: ["Diabetes (father)", "Hypertension (mother)"],
    PMHx: ["Asthma dx 2015", "Allergic rhinitis"],
    PSHx: ["Appendectomy — 2018"],
    SHx: ["Smoker (5 pack-years)", "Occasional alcohol"],
    "OB Gyne Hx": ["G1P1", "LMP: 2025-08-01"],
    Laboratory: ["Hematology", "Chemistry", "Serology", "Urinalysis"],
    Radiology: ["Chest X-Ray", "Ultrasound abdomen"],
    Vital: ["Blood Pressure", "Heart Rate", "Respiratory Rate", "Temperature"],
  };

  const organs = [
    { name: "heart", style: { top: "25%", left: "42%" } },
    { name: "leftLung", style: { top: "40%", left: "42%" } },
    { name: "liver", style: { top: "60%", left: "42%" } },
    { name: "kidney", style: { top: "70%", left: "42%" } },
    { name: "largeIntestine", style: { top: "75%", left: "42%" } },
    { name: "rightLung", style: { top: "30%", left: "54%" } },
    { name: "rightLiver", style: { top: "60%", left: "54%" } },
    { name: "stomach", style: { top: "50%", left: "54%" } },
    { name: "smallIntestine", style: { top: "67%", left: "54%" } },
  ];

  const textRefs = useRef({});
  const organRefs = useRef({});
  const [lines, setLines] = useState([]);

  const getLinePoints = () => {
    if (!containerRef.current) return [];
    const rect = containerRef.current.getBoundingClientRect();

    const pairs = [
      ["FMHx", "heart"],
      ["PMHx", "leftLung"],
      ["PSHx", "liver"],
      ["SHx", "kidney"],
      ["OB Gyne Hx", "largeIntestine"],
      ["Laboratory", "rightLung"],
      ["Radiology", "stomach"],
      ["Vital", "rightLiver"],
      ["Medications", "smallIntestine"],
    ];

    return pairs.flatMap(([text, organ]) => {
      const tEl = textRefs.current[text];
      const oEl = organRefs.current[organ];

      // dagdag condition: skip kung wala talagang contentMap entry
      if (!tEl || !oEl || (patient?.isMale && text === "OB Gyne Hx")) return [];

      const tRect = tEl.getBoundingClientRect();
      const oRect = oEl.getBoundingClientRect();

      const side = ehr.includes(text) ? "right" : "left";
      const gap = 6;

      const x1 =
        side === "left"
          ? tRect.left - rect.left - gap
          : tRect.right - rect.left + gap;
      const y1 = tRect.top + tRect.height / 2 - rect.top;

      const x2 = oRect.left + oRect.width / 2 - rect.left;
      const y2 = oRect.top + oRect.height / 2 - rect.top;

      return [{ x1, y1, x2, y2, text }];
    });
  };

  useEffect(() => {
    const update = () => setLines(getLinePoints());
    update();

    const ro = new ResizeObserver(update);
    if (containerRef.current) ro.observe(containerRef.current);

    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    // same element for add and remove, even if the ref changes later
    const bodyEl = bodyRef.current;
    if (bodyEl) bodyEl.addEventListener("load", update);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
      if (bodyEl) bodyEl.removeEventListener("load", update);
    };
    // eslint-disable-next-line
  }, [patient]);

  useEffect(() => {
    setSlide("");
    // eslint-disable-next-line
  }, [appointment?._id]);

  const handleDefaultResult = (dept) => {
    const department = getDepartment(dept);
    const { images = [], ...rest } =
      appointment[department.toLowerCase()] || {};

    if (!images.length && !Object.keys(rest).length) return false;
    var activeDiag = {};
    const results = Object.keys(rest);
    if (results.length > 0) {
      const keyRest = results[0];
      const firstRest = rest[keyRest];
      activeDiag = {
        dept: department,
        dealId: keyRest,
        section: Templates.getComponentName(firstRest[0], department),
        isImg: false,
      };
    } else {
      activeDiag = {
        ...images[0],
        dept: department,
        isImg: true,
      };
    }

    dispatch(SetPATIENT({ ...appointment, activeDiag }));
  };

  return (
    <div
      className="checkup-data-center-image"
      ref={containerRef}
      style={{ position: "relative" }}
    >
      {/* SVG Lines (same as before) */}
      <svg
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 10,
        }}
      >
        {lines.map((ln, i) => (
          <g key={i}>
            <line
              x1={ln.x1}
              y1={ln.y1}
              x2={ln.x2}
              y2={ln.y2}
              stroke="black"
              strokeWidth={slide === ln.text ? 3 : 1}
              strokeOpacity={slide === ln.text ? 1 : 0.3}
              strokeLinecap="round"
              style={{
                transition: "stroke-width 0.3s ease, stroke-opacity 0.3s ease",
              }}
            />
            <circle
              cx={ln.x1}
              cy={ln.y1}
              r={slide === ln.text ? 4 : 2}
              fill={slide === ln.text ? "black" : "gray"}
              style={{ transition: "r 0.3s ease, fill 0.3s ease" }}
            />
            <circle
              cx={ln.x2}
              cy={ln.y2}
              r={slide === ln.text ? 4 : 2}
              fill={slide === ln.text ? "black" : "gray"}
              style={{ transition: "r 0.3s ease, fill 0.3s ease" }}
            />
          </g>
        ))}
      </svg>

      {/* Medical History Buttons + lists (always visible) */}
      <div className="checkup-data-center-image-medical-history">
        {ehr
          .filter((text) => !(patient?.isMale && text === "OB Gyne Hx"))
          .map((text) => (
            <div key={text} className="history-group">
              <button
                ref={(el) => (textRefs.current[text] = el)}
                onClick={() => setSlide(slide === text ? "" : text)} // keep for highlight
                className={`${slide === text ? "active" : ""} ${
                  patient?.isMale ? "male" : "female"
                }`}
              >
                {text}
              </button>
              <History items={contentMap[text]} />

              {/* render the correct items for this label */}
            </div>
          ))}
      </div>

      {/* Body + organ anchors */}
      <div
        className="checkup-data-center-image-full-body"
        style={{ position: "relative" }}
      >
        <img
          alt="human body"
          src={BODY}
          ref={bodyRef}
          className={`checkup-data-center-image-body ${
            slide ? "active-hover" : ""
          }`}
          draggable={false}
          onClick={() => setSlide("")}
        />

        {organs.map(({ name, style }) => (
          <div
            key={name}
            ref={(el) => (organRefs.current[name] = el)}
            style={{ position: "absolute", width: 10, height: 10, ...style }}
          />
        ))}
      </div>

      {/* Ancillary Buttons + lists (always visible) */}
      <div className="checkup-data-center-image-Ancillary">
        {ancillary.map((text) => (
          <div key={text} className="history-group">
            <button
              ref={(el) => (textRefs.current[text] = el)}
              onClick={() => {
                const isSameSelction = slide === text;
                setSlide(isSameSelction ? "" : text);
                if (isSameSelction) {
                  dispatch(SetPATIENT({ ...appointment, activeDiag: {} }));
                } else {
                  if (["Laboratory", "Radiology"].includes(text)) {
                    handleDefaultResult(text);
                  } else {
                    dispatch(SetPATIENT({ ...appointment, activeDiag: {} }));
                  }
                }
              }}
              className={`${slide === text ? "active" : ""} ${
                patient?.isMale ? "male" : "female"
              }`}
            >
              {text}
            </button>

            {["Laboratory", "Radiology"].includes(text) ? (
              <DiagHistory department={text} setSlide={setSlide} />
            ) : (
              <History items={contentMap[text]} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
